import styled, { keyframes } from "styled-components";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/* ── Página full-screen com gradiente ─────────────── */
export const LoginPage = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  background: linear-gradient(150deg, #0a5c3a 0%, #0e7a4e 30%, #14a064 60%, #1cc970 85%, #2ed17c 100%);
  position: relative;
  overflow: hidden;

  /* Círculos decorativos de fundo */
  &::before {
    content: "";
    position: absolute;
    width: 600px;
    height: 600px;
    border-radius: 50%;
    background: rgba(255,255,255,0.045);
    top: -200px;
    right: -150px;
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background: rgba(255,255,255,0.035);
    bottom: -120px;
    left: -100px;
    pointer-events: none;
  }

  body.dark & {
    background: linear-gradient(150deg, #071a0f 0%, #0b2e1c 30%, #0e4025 60%, #115330 100%);
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation: none !important;
      opacity: 1 !important;
    }
  }
`;

export const TopAccent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, rgba(255,255,255,0.3), rgba(255,255,255,0.8), rgba(255,255,255,0.3));
`;

/* ── Logo acima do card ────────────────────────────── */
export const LogoArea = styled.div`
  margin-bottom: 1.75rem;
  text-align: center;
  animation: ${fadeUp} 0.5s ease both;
  position: relative;
  z-index: 1;

  img {
    height: 48px;
    filter: brightness(0) invert(1);
  }
`;

/* ── Card principal ────────────────────────────────── */
export const LoginCard = styled.div`
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow:
    0 0 0 1px rgba(0,0,0,0.04),
    0 8px 32px rgba(0,0,0,0.16),
    0 32px 80px rgba(0,0,0,0.12);
  animation: ${fadeUp} 0.5s ease both;
  animation-delay: 0.08s;
  opacity: 0;
  position: relative;
  z-index: 1;

  body.dark & {
    background: #1e2220;
    box-shadow:
      0 0 0 1px rgba(255,255,255,0.06),
      0 8px 32px rgba(0,0,0,0.5),
      0 32px 80px rgba(0,0,0,0.4);
  }

  @media (max-width: 575.98px) {
    padding: 2rem 1.5rem;
    border-radius: 1.25rem;
  }
`;

export const CardTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.25rem;
  letter-spacing: -0.02em;

  body.dark & { color: #f0f0ee; }
`;

export const CardSubtitle = styled.p`
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 1.75rem;

  body.dark & { color: #8a9085; }
`;

/* ── Rodapé do card ────────────────────────────────── */
export const RegisterRow = styled.p`
  text-align: center;
  margin: 1.25rem 0 0;
  font-size: 0.875rem;
  color: #6b7280;

  a {
    color: var(--primary);
    font-weight: 700;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }

  body.dark & { color: #8a9085; }
`;

export const TrustRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  margin-top: 1.5rem;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.65);
  position: relative;
  z-index: 1;
  animation: ${fadeUp} 0.5s ease both;
  animation-delay: 0.2s;
  opacity: 0;

  i { font-size: 0.875rem; color: rgba(255,255,255,0.85); }
`;
